export function isJsonEqual(a, b) {
	return JSON.stringify(a) === JSON.stringify(b);
}

export default {isJsonEqual};